import { jsx as _jsx } from "react/jsx-runtime";
import { MatchStatsForm, } from "./MatchStatsForm";
import { findPlayerLeagueMatchStatByPlayerAndTeam } from "./utils";
export const LeagueMatchStatsForm = ({ leagueMatch, onSubmit, homeTeamPlayers, awayTeamPlayers, canModifyHomeTeam = true, canModifyAwayTeam = true, canModifyResult = true, isSubmitting, }) => {
    const getPlayerLeagueMatchStat = findPlayerLeagueMatchStatByPlayerAndTeam(leagueMatch?.playerLeagueMatchStats || []);
    const homeTeam = leagueMatch.homeTeam;
    const awayTeam = leagueMatch.awayTeam;
    // Only surface (and submit) teams the user may modify — a manager sees only
    // their own team, the league admin sees both. The backend rejects stats for
    // teams you can't modify, so sending them would fail the whole save.
    const editableHomePlayers = canModifyHomeTeam ? homeTeamPlayers : [];
    const editableAwayPlayers = canModifyAwayTeam ? awayTeamPlayers : [];
    const allPlayers = [
        ...editableHomePlayers.map((p) => ({
            player: p,
            teamId: homeTeam.id,
        })),
        ...editableAwayPlayers.map((p) => ({
            player: p,
            teamId: awayTeam.id,
        })),
    ];
    const initialPlayerStats = allPlayers.map(({ player, teamId }) => {
        const playerLeagueMatchStat = getPlayerLeagueMatchStat(player.id, teamId);
        return {
            teamId,
            playerId: player.id,
            goalsScored: playerLeagueMatchStat?.goalsScored,
            yellowCards: playerLeagueMatchStat?.yellowCards,
            redCards: playerLeagueMatchStat?.redCards,
            id: playerLeagueMatchStat?.id,
            played: playerLeagueMatchStat
                ? playerLeagueMatchStat.played ?? true
                : false,
        };
    });
    const handleSubmit = (result, playerStats) => {
        const leagueMatchResult = {
            id: leagueMatch.leagueMatchResult?.id ?? 0,
            leagueMatchId: leagueMatch.id,
            homeTeamScore: result.leftTeamScore,
            awayTeamScore: result.rightTeamScore,
        };
        const playerLeagueMatchStats = playerStats
            .filter((stat) => stat.played !== false || stat.id !== undefined)
            .map((stat) => ({
            id: stat.id,
            playerId: stat.playerId,
            teamId: stat.teamId,
            goalsScored: stat.goalsScored,
            yellowCards: stat.yellowCards,
            redCards: stat.redCards,
            played: stat.played ?? false,
            leagueMatchId: leagueMatch.id,
        }));
        onSubmit(leagueMatchResult, playerLeagueMatchStats);
    };
    return (_jsx(MatchStatsForm, { leftTeamName: homeTeam.name, rightTeamName: awayTeam.name, leftTeamPlayers: editableHomePlayers, rightTeamPlayers: editableAwayPlayers, initialLeftScore: leagueMatch.leagueMatchResult?.homeTeamScore, initialRightScore: leagueMatch.leagueMatchResult?.awayTeamScore, initialPlayerStats: initialPlayerStats, onSubmit: handleSubmit, canModifyLeftTeam: canModifyHomeTeam, canModifyRightTeam: canModifyAwayTeam, canModifyResult: canModifyResult, showPlayedCheckbox: true, isSubmitting: isSubmitting }));
};
